import { DateTime } from "luxon";
import { printf }   from "fast-printf";

export function usePrettyDateInterval ()
{
    return ( isoDate ) =>
    {
        const dtNow     = DateTime.local( { zone : 'America/Toronto' } )
        const dtComment = DateTime.fromISO( isoDate, { zone : 'America/Toronto' } );

        const intervalSinceMinutes = Math.floor( dtNow.diff( dtComment, 'minutes' ).toObject().minutes );
        const intervalSinceHours   = Math.floor( dtNow.diff( dtComment, 'hours' ).toObject().hours );
        const intervalSinceDays    = Math.floor( dtNow.diff( dtComment, 'days' ).toObject().days );
        const isDifferentDate      = dtNow.day !== dtComment.day;

        // console.log( {
        //     dtNow,
        //     dtComment,
        //     intervalSinceMinutes,
        //     intervalSinceHours,
        //     intervalSinceDays,
        //     isDifferentDate,
        // } )


        if ( intervalSinceDays >= 1 || isDifferentDate )
        {

            return '<span class="date-date">' + dtComment.setLocale( 'fr-CA' ).toLocaleString( DateTime.DATE_FULL ) + '</span>' +
                '<span class="date-separator"> - </span>' +
                '<span class="date-time">' + dtComment.setLocale( 'fr-CA' ).toLocaleString( DateTime.TIME_24_SIMPLE ) + '</span>';

        } else if ( intervalSinceHours >= 1 )
        {
            return dtComment.setLocale( 'fr-CA' ).toLocaleString( DateTime.TIME_24_SIMPLE );
        } else
        {
            if ( intervalSinceMinutes < 2 )
            {
                return 'maintenant';
            } else
            {
                return printf( 'il y a %d minutes', intervalSinceMinutes )
            }
        }
    }
}
